const menuCurationTaskEditorFormInitialValues = values => ({
  cuisineTypeId: values.menu?.cuisineType?.id,
})

export default menuCurationTaskEditorFormInitialValues
